import type { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row, theme, Typography } from 'antd';
import { StatusTag } from 'pos-client/components/generic/status-tag/StatusTag.tsx';
import { PosInput } from 'pos-client/components/shared/Form/PosInput.tsx';
import type { RMAssetFormType } from 'pos-shared/models/resourceManagementSchema.ts';

interface CapacityTabContentProps {
  control: Control<RMAssetFormType>;
  formValues: RMAssetFormType;
}

const CapacityTabContent = ({
  control,
  formValues,
}: CapacityTabContentProps) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const { capabilities } = formValues;

  return (
    <>
      <Row style={{ marginBottom: token.marginLG }}>
        <Col span={24} style={{ marginBottom: token.marginXS }}>
          <Typography.Text>{t('locations.capabilities')}</Typography.Text>
        </Col>
        <Col span={24}>
          {!capabilities && (
            <Typography.Text>{t('common.errors.noResults')}</Typography.Text>
          )}
          {capabilities &&
            capabilities
              .split(',')
              .map((capability: string) => (
                <StatusTag key={capability} status={capability} />
              ))}
        </Col>
      </Row>
      <Row gutter={token.marginXL}>
        <Col span={12}>
          <PosInput
            control={control}
            name="capacitySettings.measure1"
            label={t('scheduling.capacityMeasures.measure1')}
            readOnly
          />
        </Col>
        <Col span={12}>
          <PosInput
            control={control}
            name="capacitySettings.measure2"
            label={t('scheduling.capacityMeasures.measure2')}
            readOnly
          />
        </Col>
      </Row>
      <Row gutter={token.marginXL}>
        <Col span={12}>
          <PosInput
            control={control}
            name="capacitySettings.measure3"
            label={t('scheduling.capacityMeasures.measure3')}
            readOnly
          />
        </Col>
        <Col span={12}>
          <PosInput
            control={control}
            name="capacitySettings.measure4"
            label={t('scheduling.capacityMeasures.measure4')}
            readOnly
          />
        </Col>
      </Row>
    </>
  );
};

export default CapacityTabContent;
